<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'app',
  components: {},
  methods: {
    ...mapActions(['init']),
  },
  mounted() {
    // 检测浏览器路由改变页面不刷新问题, hash模式的工作原理是hashchange事件
    window.addEventListener('hashchange', () => {
      const currentPath = window.location.hash.slice(1);
      if (this.$route.path !== currentPath) {
        this.$router.push(currentPath);
      }
    }, false);
    this.init();
  },
  computed: {},
};
</script>

<style lang='less'>
#app {
  width: 100%;
  height: 100vh;
  overflow-y: auto;
}
* {
  position: relative;
  margin: 0;
  padding: 0;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.detail-content ul {
  padding-left: 20px;
}
#edui_fixedlayer{
  z-index: 9999 !important;
}
body {
  font-size: 12px;
  background-color: #ffffff;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
a {
  text-decoration: none;
  cursor: pointer;
}
input,select {
  outline: none;
}
li {
  list-style: none;
}

button {
  outline: none;
}
input,
textarea {
  -webkit-appearance: none;
}
table {
  border-collapse: collapse;
}
@media screen and (min-width:960px) {
  .mint-msgbox {
    width: 350px
  }
}
.el-pagination {
  height: 40px;
  font-size: 14px;
  color: #9B9B9B;
  font-weight: normal;
}
.el-pagination.is-background .el-pager li {
  height: 40px;
  width: 40px;
  line-height: 40px;
  border: 1px solid rgba(151,151,151,0.30);
  border-radius: 6px;
  background-color: #ffffff;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #536FFF;
  border-radius: 6px;
  color: #ffffff;
}
.el-pagination.is-background .btn-prev,.el-pagination.is-background .btn-next {
  height: 40px;
  width: 40px;
  background-color: #ffffff;
  border: 1px solid rgba(151,151,151,0.30);
  border-radius: 6px;
}
.fl {
  float: left;
}
.fr  {
  float: right;
}
.bx {
  width: 1200px;
  margin: 0 auto;
}
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 5px;
}
::-webkit-scrollbar-thumb {
  /*滚动方块*/
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.2);
}
::-webkit-scrollbar-thumb:hover {
  /*滚动方块hover*/
  background-color: rgba(0, 0, 0, 0.4);
}
::-webkit-scrollbar-track {
  /*滚动条轨道*/
  /* -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.1); */
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.05);
}
.el-form-item {
  margin-bottom: 10px;
}
.login .el-form-item {
  margin-bottom: 22px;
}
.el-form-item.is-error {
  margin-bottom: 22px;
}
// .el-table {
//   font-size: 12px;
// }
.el-input__inner {
  font-size: 12px;
  // height: 40px!important;
}
.login .el-input__inner {
  height: 40px;
  // background: rgb(40, 51, 66);
  // border-color: rgba(255, 255, 255, 0.103);
  color: #2d3a4b;
}
// .login {
//   .el-input.is-active .el-input__inner, .el-input__inner:focus {
//     border-color: rgba(255, 255, 255, 0.329);
//   }
// }
// .el-button {
//   font-size: 12px;
//   height: 34px;
//   padding: 10px 20px;
// }
// .el-table__row {
//   height: 40px;
// }
.el-table thead {
  color: rgba(0,0,0,1);
  background-color: rgba(240,245,247,1);
}
.el-table td, .el-table th {
  padding: 0;
  height: 40px;
  // text-align: center;
}
// .el-table td:last-child {
//   text-align: left;
// }
.el-table th {
  height: 40px;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/App.vue